<section class="wrapper">
  <img
    src="./assets/images/empty-list.svg"
    title="Nenhum usuário encontrado."
    alt="[Imagem] Lista vazia"
  />

  <p class="wrapper__title">{{ labels[screenName].title }}</p>

  <p class="wrapper__subtitle">{{ labels[screenName].subtitle }}</p>
</section>
